// extracted by mini-css-extract-plugin
module.exports = {"footer":"_23byyv-RD3ETpkBWPH1cLv","logo":"M3RcrmeNCfsaGoXUYRxkt","right":"_1KNK9zSYqe4agU3u5cp0CK"};